export * from './customer.profile.detail.model';
export * from './customer.profile.edit.model';



// WEBPACK FOOTER //
// ./src/models/customer/index.ts